var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-search-data-provider", {
    attrs: { "api-url": _vm.apiUrl },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(dataProvider) {
          return [
            _c("v-search", {
              attrs: {
                "api-url": _vm.apiUrl,
                url: _vm.url,
                items: dataProvider.items,
                id: _vm.searchId,
                "use-animation": _vm.useAnimation,
                "max-index": dataProvider.items.length - 1,
                "input-value": _vm.inputValue,
                "is-loading": dataProvider.loading
              },
              on: { getItems: dataProvider.getItems }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }